import { css, keyframes } from "@emotion/core";
import { DESIGN_TOKEN } from "Config/design_token";
import { WORDPRESS_STYLES } from "./wordpress";
import { TABLET_LAYOUT, DESKTOP_LAYOUT, MAX_READABLE_WIDTH } from './constants';
import { MainProps } from "../main";

const fadeIn = keyframes`
  0% {
    opacity: 0;
    top: 4rem;
  }
  100% {
    opacity: 1;
    top: 0rem;
  }
`;

const computeMainPadding = (layout: MainProps["layout"]): string => {
  let padding = "6rem 2rem 2rem 2rem";
  if (layout === "DESKTOP") padding = "4rem";
  return padding;
};

/** Styling for the main content area. */
export const MAIN_STYLES = (
  layout: MainProps["layout"]
): ReturnType<typeof css> =>
  css`
    position: relative;
    display: flex;
    height: auto;
    min-height: 100vh;
    background-color: ${DESIGN_TOKEN.colors.swatch_3};
    padding: ${computeMainPadding(layout)};
    animation: ${fadeIn} 0.3s forwards;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      padding-bottom: 0.5rem;
      border-bottom: thin solid ${DESIGN_TOKEN.colors.swatch_5};
      margin-bottom: 1rem;
      font-family: ${DESIGN_TOKEN.fonts.font_1.family};
      font-style: ${DESIGN_TOKEN.fonts.font_1.style.oblique};
      font-weight: ${DESIGN_TOKEN.fonts.font_1.weight.bold};
      color: ${DESIGN_TOKEN.colors.swatch_1};
    }

    h1 {
      font-size: 2rem;
      line-height: 2.4rem;
      margin-bottom: 1rem;
    }
    h2 {
      font-size: 1.6rem;
      line-height: 1.8rem;
    }
    h3 {
      font-size: 1.4rem;
      line-height: 1.6rem;
    }

    p {
      display: block;
      width: 100%;
      max-width: 100%;
      margin-bottom: 2rem;
      font-size: 1.4rem;
      font-family: ${DESIGN_TOKEN.fonts.font_1.family};
      line-height: 2rem;
      color: ${DESIGN_TOKEN.colors.swatch_2};
    }
    p:last-of-type {
      margin-bottom: 4rem;
    }
    ${DESKTOP_LAYOUT} p {
      max-width: ${MAX_READABLE_WIDTH};
    }

    a {
      color: ${DESIGN_TOKEN.colors.swatch_6};
      text-decoration: none;
    }
    a:hover {
      text-decoration: underline;
    }

    table {
      margin-bottom: 1rem;
      border: 1rem solid ${DESIGN_TOKEN.colors.swatch_5};
    }
    tr:nth-of-type(odd) {
      background-color: ${DESIGN_TOKEN.colors.swatch_5};
    }
    td {
      padding: 0.5rem;
      font-size: 1rem;
    }

    .layout {
      width: 100%;
      max-width: 100%;
    }

    ${WORDPRESS_STYLES}
  `;
